import { useMutation } from "@/compat/reactQuery";
import riskAssessmentService from "../../services/riskAssessmentService";

const useAddRiskAssessment = () => useMutation(riskAssessmentService.addRiskAssessment);

export default useAddRiskAssessment;
